import request from '@/utils/request.js'



/**
 * 服务订单首单回访记录
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrderSingleReturnInfo(params) {
    return request({
        url: '/tradeService/api/app/orderServiceProduct/getOrderSingleReturnInfo',
        method: 'post',
        data: params
    })
}